module.exports = __webpack_public_path__ + "static/img/way.185f5011.svg";